<div class="filters-container" *ngIf="isFilterPanelOpen">
	<div class="filter-empty-state" *ngIf="filters?.length === 0">
		<capra-icon class="icon-no-filters"></capra-icon>
		<p>Add filters to your report by clicking the Add Filter link at the top of the page.</p>
	</div>
	<div class="cta-container {{ buttonPosition }}" *ngIf="filters && buttonPosition === 'top'">
		<capra-button
			*ngIf="!showSetDefault"
			[disabled]="!isDirty"
			class="reset-cta"
			text="Reset"
			variant="secondary"
			size="small"
			color="neutral"
			(clicked)="onResetAllFilters()"
		></capra-button>
		<capra-button
			*ngIf="showSetDefault"
			[disabled]="!isDirty"
			class="set-as-default-cta"
			text="Set as default"
			variant="secondary"
			size="small"
			color="neutral"
			(clicked)="setDefault()"
		></capra-button>
		<capra-button
			text="Apply changes"
			variant="primary"
			size="small"
			color="default"
			(clicked)="apply()"
		></capra-button>
	</div>
	<div *ngIf="filters"
		class="filter-type-container"
		dndDropzone
		(dndDrop)="onDrop($event)">
		<div *ngFor="let filter of filters; last as isLast; trackBy: trackByFn">
			<mode-filter-container
				[class.last]="isLast"
				[filter]="filter"
				[filterOption]="filterOptions[filter.token]"
				[isLoading]="!filter.isLoaded"
				[showSettingsMenu]="showSettingsMenu"
				[isOrphan]="orphanedFilters.has(filter.token)"
				[tooManySelected]="hasTooManySelected(filter.token)"
				[isCalc]="isCalcField(filter.token)"
				[showDropdownToggle]="ffDropdownEnabled"
				[dragAndDropEnabled]="ffDragAndDropEnabled"
				[displayRelevantValuesEnabled]="ffDisplayRelevantValuesEnabled"
				(updateSelectControlType)="onSelectControlTypeChange($event.field, $event.type)"
				(updateReportFilterType)="onUpdateReportFilterType($event.field, $event.type)"
				(selectChange)="onSelectChange($event.token, $event.selection)"
				(multiSelectChange)="onMultiSelectChange($event.filter, $event.selection, $event.searchTerm)"
				(dragStarted)="onDragStart($event)"
				(dragEnded)="onDragEnd()"
				(deleteFilter)="onDeleteFilter($event)"
				(rangeChange)="onRangeChange($event.filter, $event.token)"
				(moveFilterToTop)="onMoveFilter($event.token, 'top')"
				(moveFilterToBottom)="onMoveFilter($event.token, 'bottom')"
				(moveFilterUp)="onMoveFilter($event.token, 'up')"
				(moveFilterDown)="onMoveFilter($event.token, 'down')"
				(resetFilter)="onResetFilter($event)"
				(showAll)="onShowAllChanged($event.token, $event.shouldShowAll)"
				(showRelevantValues)="onShowRelevantValuesChanged($event.filterToken, $event.showRelevantValues)"
			></mode-filter-container>
		</div>
		<div dndPlaceholderRef class="placeholder"></div>
	</div>
	<div class="cta-container {{ buttonPosition }}" *ngIf="filters && buttonPosition === 'bottom'">
		<capra-button
			*ngIf="!showSetDefault"
			[disabled]="!isDirty"
			class="reset-cta"
			text="Reset"
			variant="secondary"
			size="small"
			color="neutral"
			(clicked)="onResetAllFilters()"
		></capra-button>
		<capra-button
			*ngIf="showSetDefault"
			[disabled]="!isDirty"
			class="set-as-default-cta"
			text="Set as default"
			variant="secondary"
			size="small"
			color="neutral"
			(clicked)="setDefault()"
		></capra-button>
		<capra-button
			text="Apply changes"
			variant="primary"
			size="small"
			color="default"
			(clicked)="apply()"
		></capra-button>
	</div>
</div>
